var main = (function($) {
  function init() {

    var siteNavigation = $('.main-menu-area li.menu-item-has-children ul.sub-menu');

      siteNavigation.find( 'a' ).on( 'focus blur', function() {

      $( this ).parents( 'ul' ).toggleClass( 'focus' );

    });

    // disable form submit on enter key press in text fields, instead focus next field
    $('input[type=text]').keypress(function(e){
        if ( e.which == 13 ) {
            var index = $('input').index(this) + 1;
            $('input').eq(index).focus();
            e.preventDefault();
        }
    });

   // Open PDF files in new tab.
    $('a[href$=".pdf"]').prop('target', '_blank');

    // Track phone number link clicks (in Analytics: Behaviour > Events, in Finnish Käyttäytyminen > Tapahtumat)
    $('a[href^="tel:"]').click(function(){

      var phonenumber = $( this ).attr( 'href' );

      //console.log( 'You clicked on the phone number ' + phonenumber + '. Hello, is it me you´re looking for?' );

      ga('send', {
        hitType: 'event',
        eventCategory: 'Puhelinnumero',
        eventAction: 'click',
        eventLabel: phonenumber
      });

    });

    // Track mail address link clicks (in Analytics: Behaviour > Events, in Finnish Käyttäytyminen > Tapahtumat)
    $('a[href^="mailto:"]').click(function(){

      var mailaddress = $( this ).attr( 'href' );

      //console.log( 'You clicked on the mail link ' + mailaddress + '.' );

      ga('send', {
        hitType: 'event',
        eventCategory: 'Sähköpostiosoite',
        eventAction: 'click',
        eventLabel: mailaddress
      });

    });

    // Track PDF link clicks (in Analytics: Behaviour > Events, in Finnish Käyttäytyminen > Tapahtumat)
    $('a[href$=".pdf"]').click(function(){

      var pdfaddress = $( this ).attr( 'href' );

      //console.log( 'You clicked on the PDF link ' + pdfaddress + '.' );

      ga('send', {
        hitType: 'event',
        eventCategory: 'PDF file',
        eventAction: 'click',
        eventLabel: pdfaddress
      });

    });

    // Open external links in new window.
    $('a').each(function() {

      var a = new RegExp('/' + window.location.host + '/');
      var b = new RegExp('javascript:');
      var c = new RegExp('mailto:');
      var d = new RegExp('tel:');

      if( !a.test(this.href) && !b.test(this.href) && !c.test(this.href) && !d.test(this.href) ) {

        $(this).click(function(event) {

          event.preventDefault();
          event.stopPropagation();
          window.open(this.href, '_blank');

        });

      }

    });

    // smooth scroll
    $(function() {
        $('a[href*="#"]:not([href="#"])').click(function() {
            if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
                if (target.length) {
                    $('html, body').animate({
                        scrollTop: target.offset().top
                    }, 1000);
                    return false;
                }
            }
        });
    });

    // Sometimes we have a back button on single pages. This makes it function as the browser back button.

    var thishost = window.location.hostname;

    if ( document.referrer && document.referrer.indexOf(window.location.host) !== -1 ) {

      //console.log('Referrer is same domain.');

      $( '.back-button' ).click(function(e) {

        //console.log('You clicked the button!');

        // We cannot use history.go(-1); because it does not work if we opened the page into a new tab

        window.location.href = document.referrer;
        e.preventDefault();

      });

    }

    if( $('html').attr('lang') === 'fi' ) {

      $('span.elm-button-text').text('Näytä lisää ajankohtaisia');

    }

    if( $('html').attr('lang') === 'sv-SE' ) {

      $('span.elm-button-text').text('Visa fler');

    }

    $('.toggle-search-field-visibility').click(function(){

      $( this ).remove();
      $('.search-and-languages .search').addClass( 'active' );
      $('.search-and-languages .search input').focus();

    });

    $( 'input[name=hintatoggle]' ).click(function(){

      $( 'span.kokonaishinta' ).addClass( 'd-none' );
      $( 'span.omavastuuosuus' ).addClass( 'd-none' );

      var showthis = $( 'input[name=hintatoggle]:checked' ).val();

      $( 'span.' + showthis ).removeClass( 'd-none' );

    });

    $( '.togglelist' ).click(function(e){

      var whichlist = $( this ).attr( 'rel' );

      $( '.' + whichlist ).toggleClass( 'd-none' );

      if( $( '.' + whichlist ).hasClass( 'd-none' ) ) {

        $( this ).removeClass( 'active' );

      }
      else {

        $( this ).addClass( 'active' );

      }

      e.preventDefault();

    });

    // Fixes for responsive menu
    // -------------------------

    // Fix language translations for search bar
    var currentLanguage = $('html').attr('lang');
    if(currentLanguage == 'fi') {
      $('body').find('.responsive-menu-search-box').attr("placeholder", "Etsi");
    }
    if(currentLanguage == 'sv-SE') {
      $('body').find('.responsive-menu-search-box').attr("placeholder", "Sök");
    }

    // Shorten language names in responsive menu
    $('body').find('a.responsive-menu-item-link[hreflang="en-GB"]').html('ENG');
    $('body').find('a.responsive-menu-item-link[hreflang="sv-SE"]').html('SWE');
    $('body').find('a.responsive-menu-item-link[hreflang="fi"]').html('FIN');

    if( $('.hero-image')[0] ) {

      $( '#responsive-menu-button' ).addClass( 'we-have-hero-image' );

    }

    $(function(){
      if( $(window).width() > 576 ) {
        $( '.player' ).mb_YTPlayer();
      }
    });


    $(function(){
      $('.menu-toggle').click(function(evt) {
        evt.preventDefault();
        $('header.responsive-nav').toggleClass('open');
      });

      $('li.lang-item').click(function(evt) {
        var href = $(this).children('a').attr('href');
        window.location = href;
      });

      $('.submenu-toggle').click(function(evt) {
        evt.preventDefault();
        $(this).parent('li').toggleClass('open-submenu');
      });
    });

    $('.info-icon').click(function(event){

      event.preventDefault();

    });

    if ( $( ".pricelist" ).length ) {
      $('[data-toggle="tooltip"]').tooltip();
    }
  }

  var animation = bodymovin.loadAnimation({
    container: document.getElementById('logo-animation'),
    renderer: 'svg',
    loop: false,
    autoplay: true,
    path: '/wp-content/themes/snell2017/built-assets/images/data.json',
  })

  return {
    init: init
  };
}(jQuery));
